export { NotificationsService } from './notifications/notifications.service';
export { InscriptosActividadService } from './inscriptos-actividad/inscriptos-actividad.service';
export { MailService } from './mail/mail.service';
export { TrabajosInvitadosService } from './trabajos-invitados/trabajos-invitados.service';
export { CategoriaTrabajoInvitadoService } from './categoria-trabajo-invitado/categoria-trabajo-invitado.service';
export { TrabajosService } from './trabajos/trabajos.service';
export { UploadService } from './upload/upload.service';
export { AdminGuard } from './guards/admin.guard';
export { CodigoInvitacionService } from './codigo-inscripcion/codigo-inscripcion.service';
export { CongresosService } from './congresos/congresos.service';
export { CategoriaTrabajoService } from './categoria-trabajo/categoria-trabajo.service';
export { CategoriaInscripcionService } from './categoria-inscripcion/categoria-inscripcion.service';
export { SidebarService } from './shared/sidebar.service';
export { LoginGuard } from './guards/login.guard';
export { UserService } from './user/user.service';
export { TranslationService } from './translation/translation.service';
export { ActividadesService } from './actividades/actividades.service';



// WEBPACK FOOTER //
// ./src/app/services/services.index.ts